import {z} from 'zod';
import {FEATURE_FLAGS} from '@packages/systems/feature-config/shared';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'get-site-branch-freshness' as const;

const argumentZod = z.object({
  siteBranchId: z
    .string()
    .min(1)
    .describe('Site-branch id from list-site-branches.'),
});

export const getSiteBranchFreshnessManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Get site branch freshness',
  family: 'site-branches',
  llmTool: {
    name: toolName,
    description:
      'Checks whether a live site-scope branch (Releases) is behind main for the current site. Returns status: ready (up to date), needs_update (main has changed since the branch was created or last updated), updating (an update from main is running; activeTaskId is that task), or unknown (with a reason). Also returns coverage (complete, partial, unknown). If the branch is being merged, returns a branch_merge_in_progress error; wait a few seconds and try again. Merged branches return not found.',
    inputSchema: argumentZod,
  },
  type: 'server',
  featureGate: FEATURE_FLAGS.SITE_BRANCHES,
  requiredScopes: ['branches:read'],
  permission: [{resource: 'Site', action: 'read'}],
  confirmBeforeExecuting: false,
  isConcurrencySafe: () => true,
  isReadOnly: () => true,
});

export type GetSiteBranchFreshnessArgumentType = z.infer<typeof argumentZod>;
